import type { TextareaHTMLAttributes } from 'react';

import type { CommentSide } from '../inbox/prs/changes/types/comment';

export const TEXTAREA_VARIANTS = {
  default: 'default',
  // This is used for reply buttons (in discussion component)
  reply: 'reply',
  // This is used for editing text areas that have saved content
  editingSavedContent: 'editingSavedContent',
  // This is used for PR comments, must implement onAddToReview
  prComment: 'prComment',
  // This is used for PR replies, only shows submit button
  prReply: 'prReply',
} as const;

export type TextareaVariant = (typeof TEXTAREA_VARIANTS)[keyof typeof TEXTAREA_VARIANTS];

export type AiSuggestionInput = {
  comment: string;
  replyCodeContext?: string;
  fileContext?: string;
};

export type AutosizeTextAreaProps = {
  owner: string;
  repo: string;
  maxHeight?: number;
  minHeight?: number;
  showSendButton?: boolean;
  variant?: TextareaVariant;
  hideButtonsUntilFocus?: boolean;
  onAiSuggestion?: (input: AiSuggestionInput, onStream: (text: string) => void) => Promise<void>;
  onGetCodeLine?: () => string | undefined;
  replyCodeContext?: string;
  fileContext?: string;
  defaultValue?: string;
  enableUserMentions?: boolean;
  handleSubmit?: (text: string) => void;
  handleCancel?: () => void;
  isStreamingText?: boolean;
  onAddToReview?: (text: string) => void; // Callback for adding comment to review in PR
  disablePostImmediately?: boolean; // In variant prReply, we should disable the post immediately button if a review has been started on this PR
  /**
   * Additional buttons to render alongside the default buttons.
   * These will be rendered in the button group before the default buttons.
   */
  extraButtonNodes?: React.ReactNode;
  side?: CommentSide;
} & TextareaHTMLAttributes<HTMLTextAreaElement>;

export type AutosizeTextAreaRef = {
  textArea: HTMLTextAreaElement;
  focus: () => void;
  maxHeight: number;
  minHeight: number;
  clear: () => void;
};
